import { CodeBase } from "./_codeBase";

export type ViewProgressSettingDivCode = '01' | '02';

/** ビュー進捗表設定区分*/
export class ViewProgressSettingDiv extends CodeBase<ViewProgressSettingDiv>
{
    /** ビュー進捗表設定区分: "01", "タイプ1"*/
    public static readonly NORMAL_MODE: ViewProgressSettingDiv = new ViewProgressSettingDiv("01" as ViewProgressSettingDivCode, "タイプ1", "");
    /** ビュー進捗表設定区分: "02", "タイプ2"*/
    public static readonly CONDITION_MODE: ViewProgressSettingDiv = new ViewProgressSettingDiv("02" as ViewProgressSettingDivCode, "タイプ2", "");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): ViewProgressSettingDiv[] {
        return [
            ViewProgressSettingDiv.NORMAL_MODE,
            ViewProgressSettingDiv.CONDITION_MODE,
        ];
    }
}
